export default "__VITE_PUBLIC_ASSET__4e3ac424__"